import { useCloudSettingsQuery, useSegmentFilterCascaded, useGridFilters } from "@repo/baseCloud";
import { emptySegmentFilters, MarketersDropdown } from "@repo/baseCloud/components";
import { FilterDropdown, FiltersV2 } from "@repo/ui";
import { useQuery } from "@tanstack/react-query";
import { useCallback } from "react";

import type { BackgroundChecksFilter } from "./types";

import BackgroundChecksApi from "../../api/backgroundChecksApi";
import { BackgroundChecksGrid } from "./grid";

const initialFilters: BackgroundChecksFilter = {
	currentPage: 1,
	itemsPerPage: 25,
	startDate: null,
	endDate: null,
	brandIds: emptySegmentFilters.brandIds,
	channelIds: emptySegmentFilters.channelIds,
	marketerIds: emptySegmentFilters.marketerIds,
	stateIds: emptySegmentFilters.stateIds,
	branchIds: emptySegmentFilters.branchIds,
	status: undefined,
	screeningProviderId: undefined,
};

export function BackgroundChecksPage() {
	const {
		filters,
		setFilters,
		appliedFilters: executedFilters,
		setAppliedFilters: setExecutedFilters,
		filtersProps,
	} = useGridFilters(initialFilters);
	const availableSegments = useSegmentFilterCascaded(emptySegmentFilters);

	const providersQuery = useQuery({
		queryKey: ["screeningProviders"],
		queryFn: () => BackgroundChecksApi.getScreeningProviders(),
	});

	const { settings } = useCloudSettingsQuery();

	const filterChanged = useCallback(
		(value: any, name: string) => {
			setFilters((prev) => ({ ...prev, [name]: value }));
		},
		[setFilters],
	);

	return (
		<div className="w-full">
			<FiltersV2 {...filtersProps}>
				<FilterDropdown
					id="screeningProviderId"
					objectName="Providers"
					textProp="Name"
					valueProp="ScreeningProviderId"
					values={providersQuery.data ?? []}
					value={filters.screeningProviderId}
					changeHandler={filterChanged}
					fullLength
					allOption
				/>
				<MarketersDropdown
					options={availableSegments.marketers}
					loaded={availableSegments.marketersLoaded}
					value={filters.marketerIds ?? []}
					changeHandler={filterChanged}
				/>
			</FiltersV2>
			<BackgroundChecksGrid
				filters={executedFilters}
				setFilters={setExecutedFilters}
				bulkImportEnabled={settings?.backgroundChecks.canBulkImport ?? false}
			/>
		</div>
	);
}
